export const mimeTypes = {
    pdf: 'application/pdf',
    bmp: 'image/bmp',
    png: 'image/png',
    jpeg: 'image/jpeg',
    json: 'application/json',
    xml: 'application/xml',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
